<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['tweets', 'articles']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left; margin-bottom: 0; line-height: 50px">Entity Cloud</div>
              <v-dialog style="float: right" v-model="entityCloudDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Entity Cloud</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullEntityCloud'], 'FullEntityCloud')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="entityCloudDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullEntityCloud" ref="FullEntityCloud" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="entityCloudDialog">
                    <EntityCloud v-bind:options="{}" v-bind:filters="getFilters"></EntityCloud>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['EntityCloud'], 'EntityCloud')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            
            <v-card class="d-flex justify-center align-center" style="min-height: 450px;">
              <v-card-text class="px-0 pt-0">
                <center id="EntityCloud" ref="EntityCloud" style="height: 315px;">
                  <EntityCloud v-bind:options="{}" v-bind:filters="getFilters"></EntityCloud>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      
      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Entity Graph</div><span class="caption pa-3" style="color:grey;margin-bottom: 0;line-height: 50px" v-html="sortByGraph"></span>
              <v-dialog style="float: right" v-model="entitiesRelatedGraphChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Entity Graph</p>
                    <v-menu v-model="dialogMenu" :close-on-content-click="false" class="right" v-if="entitiesRelatedGraphChartDialog">
                      <v-btn
                        @click.stop="dialogMenu = true" 
                        slot="activator"
                        color="primary"
                        dark
                        fab
                        small
                        class="float: right" 
                        flat
                        style="margin-top:4px; margin-right:0px">
                        <v-icon>fas fa-sliders-h </v-icon>
                      </v-btn>
                      <v-card>
                        <v-list>
                          <v-list-tile>
                           <v-btn-toggle
                              overflow
                              hide-details
                              mandatory
                              v-model="sortGraph"
                              class="transparent right"
                              style="float: left;margin: 6px 10px; box-shadow:none;-webkit-box-shadow:none">
                              <v-tooltip top>
                              <span>Sort by most Tweeted</span>
                              <v-btn slot="activator" flat color="blue lighten-2" @click.stop="" value="_tweet_count">
                                <v-icon>fab fa-twitter</v-icon>
                              </v-btn>
                              </v-tooltip>
                              <!--<v-tooltip top>
                                <span>Sort by most Retweeted</span>
                                <v-btn slot="activator" flat color="green lighten-2" @click.stop="" value="_retweet_count">
                                  <v-icon>fas fa-retweet</v-icon>
                                </v-btn>
                              </v-tooltip>
                              <v-tooltip top>
                                <span>Sort by most Favorited</span>
                                <v-btn slot="activator" flat color="red lighten-2" @click.stop="" value="_favorite_count">
                                  <v-icon>fas fa-heart</v-icon>
                                </v-btn>
                              </v-tooltip>
                              <v-tooltip top>
                                <span>Sort by most Replied</span>
                                <v-btn slot="activator" flat color="blue lighten-1" @click.stop="" value="_reply_count">
                                  <v-icon>fas fa-comment</v-icon>
                                </v-btn>
                              </v-tooltip>
                              <v-tooltip top>
                                <span>Sort by most Quoted</span>
                                <v-btn slot="activator" flat color="teal lighten-2" @click.stop="" value="_quote_count">
                                  <v-icon>fas fa-quote-right</v-icon>
                                </v-btn>
                              </v-tooltip>-->
                              <v-tooltip top>
                                <span>Sort by Latest</span>
                                <v-btn slot="activator" flat color="orange lighten-2" @click.stop="" value="_created_at">
                                  <v-icon>fas fa-calendar</v-icon>
                                </v-btn>
                              </v-tooltip>
                            </v-btn-toggle>
                          </v-list-tile>
                        </v-list>
                        <v-divider></v-divider>
                          <v-menu offset-y class="left pl-3 pt-2">
                            <v-btn
                              slot="activator"
                              color="primary"
                              dark
                              v-model="entityLimit">
                              Limit: {{entityLimit}}
                            </v-btn>
                            <v-list>
                              <v-list-tile
                                v-for="item in entityLimits"
                                :key="item"
                                @click="entityLimit = item">
                                <v-list-tile-title>{{ item }}</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                          <v-btn-toggle
                            overflow
                            hide-details
                            mandatory
                            v-model="layout"
                            class="transparent pr-3 pt-2"
                            style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                            <v-tooltip top>
                            <span>Force layout</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="force">
                              <v-icon>fas fa-code-branch</v-icon>
                            </v-btn>
                          </v-tooltip>
                          <v-tooltip top>
                            <span>Circular layout</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="circular">
                              <v-icon>fas fa-spinner</v-icon>
                            </v-btn>
                          </v-tooltip>
                        </v-btn-toggle>
                        <v-btn-toggle
                          overflow
                          hide-details
                          v-model="singles"
                          class="transparent px-2 pt-2"
                          style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                          <v-tooltip top>
                            <span>Singlets</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="singles">
                              <v-icon>far fa-dot-circle </v-icon>
                            </v-btn>
                          </v-tooltip>
                        </v-btn-toggle>
                        <v-card-actions style="clear:both;">
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click="dialogMenu = false">Ok</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                    <v-btn style="float: right;" flat icon color="primary" class="mx-0" @click.stop="snap($refs['FullEntityRelatedGraphChart'], 'FullEntityRelatedGraphChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="entitiesRelatedGraphChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullEntityRelatedGraphChart" ref="FullEntityRelatedGraphChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="entitiesRelatedGraphChartDialog">
                    <EntityRelatedGraphChart style="height:100%" v-bind:options="{sortBy: this.sortGraph, order: 'DESC', layout: this.layout, pageSize: entityLimit}" v-bind:filters="getFilters"></EntityRelatedGraphChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['EntityRelatedGraphChart'], 'EntityRelatedGraphChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
              <v-menu v-model="menu" :close-on-content-click="false" class="right">
                <v-btn
                  @click.stop="menu = true" 
                  slot="activator"
                  color="primary"
                  dark
                  fab
                  small
                  class="float: right" 
                  flat
                  style="margin-top:4px; margin-right:0px">
                  <v-icon>fas fa-sliders-h </v-icon>
                </v-btn>
                <v-card>
                  <v-list>
                    <v-list-tile>
                     <v-btn-toggle
                        overflow
                        hide-details
                        mandatory
                        v-model="sortGraph"
                        class="transparent right"
                        style="float: left;margin: 6px 10px; box-shadow:none;-webkit-box-shadow:none">
                        <v-tooltip top>
                        <span>Sort by most Tweeted</span>
                        <v-btn slot="activator" flat color="blue lighten-2" @click.stop="" value="_tweet_count">
                          <v-icon>fab fa-twitter</v-icon>
                        </v-btn>
                        </v-tooltip>
                        <!--<v-tooltip top>
                          <span>Sort by most Retweeted</span>
                          <v-btn slot="activator" flat color="green lighten-2" @click.stop="" value="_retweet_count">
                            <v-icon>fas fa-retweet</v-icon>
                          </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Sort by most Favorited</span>
                          <v-btn slot="activator" flat color="red lighten-2" @click.stop="" value="_favorite_count">
                            <v-icon>fas fa-heart</v-icon>
                          </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Sort by most Replied</span>
                          <v-btn slot="activator" flat color="blue lighten-1" @click.stop="" value="_reply_count">
                            <v-icon>fas fa-comment</v-icon>
                          </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Sort by most Quoted</span>
                          <v-btn slot="activator" flat color="teal lighten-2" @click.stop="" value="_quote_count">
                            <v-icon>fas fa-quote-right</v-icon>
                          </v-btn>
                        </v-tooltip>-->
                        <v-tooltip top>
                          <span>Sort by Latest</span>
                          <v-btn slot="activator" flat color="orange lighten-2" @click.stop="" value="_created_at">
                            <v-icon>fas fa-calendar</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </v-btn-toggle>
                    </v-list-tile>
                  </v-list>
          
                  <v-divider></v-divider>
          
                      <v-menu offset-y class="left pl-3 pt-2">
                        <v-btn
                          slot="activator"
                          color="primary"
                          dark
                          v-model="entityLimit">
                          Limit: {{entityLimit}}
                        </v-btn>
                        <v-list>
                          <v-list-tile
                            v-for="item in entityLimits"
                            :key="item"
                            @click="entityLimit = item">
                            <v-list-tile-title>{{ item }}</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>

                      <v-btn-toggle
                        overflow
                        hide-details
                        mandatory
                        v-model="layout"
                        class="transparent pr-3 pt-2"
                        style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                        <v-tooltip top>
                            <span>Force layout</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="force">
                              <v-icon>fas fa-code-branch</v-icon>
                            </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Circular layout</span>
                          <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="circular">
                            <v-icon>fas fa-spinner</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </v-btn-toggle>
                      <v-btn-toggle
                        overflow
                        hide-details
                        v-model="singles"
                        class="transparent px-2 pt-2"
                        style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                        <v-tooltip top>
                          <span>Singlets</span>
                          <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="singles">
                            <v-icon>far fa-dot-circle </v-icon>
                          </v-btn>
                        </v-tooltip>
                      </v-btn-toggle>
                  <v-card-actions style="clear:both;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="menu = false">Ok</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
            <v-card style="height:450px">
              <v-card-text id="EntityRelatedGraphChart" ref="EntityRelatedGraphChart" style="height:100%">
                <EntityRelatedGraphChart style="height:100%" v-bind:options="{sortBy: this.sortGraph, order: 'DESC', layout: this.layout, pageSize: entityLimit}" v-bind:filters="getFilters"></EntityRelatedGraphChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      
      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Most Discussed Entities</div>
              <v-dialog style="float: right" v-model="entitiesPieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Most Discussed Entities</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullEntitiesPieChart'], 'FullEntitiesPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="entitiesPieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullEntitiesPieChart" ref="FullEntitiesPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="entitiesPieChart">
                    <EntitiesPieChart v-bind:options="{}" v-bind:filters="getFilters"></EntitiesPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['EntitiesPieChart'], 'EntitiesPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="EntitiesPieChart" ref="EntitiesPieChart" style="height: 100%">
                <EntitiesPieChart v-bind:options="{}" v-bind:filters="getFilters"></EntitiesPieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Most Discussed Entity Categories</div>
              <v-dialog style="float: right" v-model="entityTypesPieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Most Discussed Entity Categories</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullEntityTypesPieChart'], 'FullEntityTypesPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="entityTypesPieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullEntityTypesPieChart" ref="FullEntityTypesPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="entityTypesPieChart">
                    <EntityTypesPieChart v-bind:options="{}" v-bind:filters="getFilters"></EntityTypesPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['EntityTypesPieChart'], 'EntityTypesPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="EntityTypesPieChart" ref="EntityTypesPieChart" style="height: 100%">
                <EntityTypesPieChart v-bind:options="{}" v-bind:filters="getFilters"></EntityTypesPieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Entity River</div>
              <v-dialog style="float: right" v-model="entitiesTweetsRiverChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Entity Graph</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullEntityTweetsRiverChart'], 'FullEntityTweetsRiverChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn icon dark @click.native="entitiesTweetsRiverChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullEntityTweetsRiverChart" ref="FullEntityTweetsRiverChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="entitiesTweetsRiverChartDialog">
                    <EntityTweetsRiverChart v-bind:options="{}" v-bind:filters="getFilters"></EntityTweetsRiverChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['EntityTweetsRiverChart'], 'EntityTweetsRiverChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 400px">
              <v-card-text id="EntityTweetsRiverChart" ref="EntityTweetsRiverChart" style="height: 100%">
                <EntityTweetsRiverChart v-bind:options="{}" v-bind:filters="getFilters"></EntityTweetsRiverChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { snap } from '@/helpers/snapshots'
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import EntitiesPieChart from './charts/EntitiesPieChart.vue'
import EntityTypesPieChart from './charts/EntityTypesPieChart.vue'
import EntityCloud from './clouds/EntityCloud.vue'
import EntityRelatedGraphChart from './charts/EntityRelatedGraphChart.vue'
import EntityTweetsRiverChart from './charts/EntityTweetsRiverChart.vue'

export default {
  data () {
    return {
      entitySort: [
        {color: 'blue lighten-3', icon: 'fab fa-twitter ', text: 'Tweets', value: '_tweet_count'},
        {color: 'green lighten-2', icon: 'fas fa-retweet', text: 'Retweet', value: '_retweet_count'},
        {color: 'red lighten-2', icon: 'fas fa-heart', text: 'Favorite', value: '_favorite_count'},
        {color: 'blue lighten-2', icon: 'fas fa-comment', text: 'Reply', value: '_reply_count'},
        {color: 'teal lighten-2', icon: 'fas fa-quote-right', text: 'Quote Tweet', value: '_quote_count'},
        {color: 'orange lighten-2', icon: 'fas fa-calendar', text: 'Date', value: '_created_at'}
      ],
      menu: false,
      dialogMenu: false,
      entityLimits: [25, 35, 50, 75, 100],
      entityLimit: 35,
      sortBy: '_tweet_count',
      sortGraph: '_tweet_count',
      singles: 'singles',
      layout: 'circular',
      orderBy: 'DESC',
      expansionValue: 0,
      entitiesPieChart: false,
      entityTypesPieChart: false,
      entitiesRelatedGraphChartDialog: false,
      entitiesTweetsRiverChartDialog: false,
      entityCloudDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('filters', ['getFilters']),
    ...mapGetters('toggles', ['getFiltersChips']),
    sortByGraph () {
      for (let x = 0; x < this.entitySort.length; x++) {
        if (this.entitySort[x].value === this.sortGraph) {
          return 'Sorted by: ' + this.entitySort[x].text
        }
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap
  },
  components: {
    Filters,
    Counters,
    EntitiesPieChart,
    EntityTypesPieChart,
    EntityCloud,
    EntityRelatedGraphChart,
    EntityTweetsRiverChart
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Entities.vue